(ns ycweb.app.website.myaccount.aftersales.cases
  (:require
   [rum.core :as rum]
   [ycweb.app.website.common :as web-common]
   [ycweb.app.website.myaccount.common :as awm.common]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.common :as cmn]
   [ycweb.components.flow :as flow]
   [ycweb.components.headings :as headings]
   [ycweb.components.toaster :as toaster]
   [ycweb.components.transitions :as t]
   [ycweb.util.comms :as comms]
   [ycweb.util.core :as u]
   [ycweb.util.date :as ud]
   [ycweb.util.urlstate :as urlstate]))


(rum/defc aftersales-history-line [app-atom return-case]
  (let [{:return-case/keys [date-added status item-count return-order]} return-case]
    [:tr.yc-tr
     [:th.yc-th
      {:scope "row"
       :data-th "Reference no:"
       :id (str "returncase_" (:ent/uuid return-case))}
      [:a.text-link
       ;;todo - link should be uuid
       ;;todo - redirect needed?
       {:href (str "/myaccount.htm?action=viewreturn&ruuid=" (:ent/uuid return-case))}
       (:ent/display-name return-case)]]
     [:td.yc-td.yc-td--centered
      [:span.yc-td__faux-table {:data-th "Requested"}
       [:span.yc-td__faux-td
        [:span.clip-date.unclip-date--t.clip-date--ma.unclip-date--l
         {:data-date (ud/date-format (ud/coerce-date date-added) "dd/MM/YY")}
         [:span.clip-date__text (ud/date-format (ud/coerce-date date-added) "dd MMM YYYY")]]]]]
     [:td.yc-td.yc-td--centered
      [:span.yc-td__faux-table {:data-th "Status"}
       [:span.yc-td__faux-td
        {:class
         (cond
           (contains?
             #{"Repairs Complete" "Resolved"}
             status)
           "text-status--success"

           (= status "Cancelled")
           "text-status--error"

           (contains?
             #{"Pending" "Processing" "Requiring Credit"}
             status)
           "text-status--warning"

           :else
           "text-status--info")}
        status]]]
     [:td.yc-td.yc-td--centered
      [:span.yc-td__faux-table {:data-th "Resolution"}
       [:span.yc-td__faux-td
        (when (:ent/uuid return-order)
          ;;todo - link should be uuid
          ;;todo - redirect needed?
          [:a.text-link (urlstate/href-props app-atom "myaccount" "trackview" {:uuid (:ent/uuid return-order)})
           (:ent/display-name return-order)])]]]
     [:td.yc-td.yc-td--centered
      [:span.yc-td__faux-table {:data-th "Items"}
       [:span.yc-td__faux-td
        item-count]]]
     [:td.yc-td.yc-td--centered
      [:span.yc-td__faux-table {:data-th "Options"}
       [:span.yc-td__faux-td

        ;;todo - link should be uuid
        ;;todo - redirect needed?
        (if (:ent/uuid return-order)
          [:a.text-link (urlstate/href-props app-atom "myaccount" "trackview" {:uuid (:ent/uuid return-order)})
           "View Resolution"]

          ;;todo - redirect needed?
          [:a.text-link (urlstate/href-props app-atom "myaccount" "viewreturn" {:uuid (:ent/uuid return-case)})
           "View Return Case"])]]]]))

(rum/defc aftersales-history-table < rum/reactive [app-atom]
  (let [action-atom (cmn/action-cursor app-atom)
        aftersales-list-settings-atom (rum/cursor-in app-atom [:myaccount :aftersaleslist])

        aftersale-cases (cmn/curact action-atom [:return-cases])
        {:keys [pages]} (rum/react aftersales-list-settings-atom)

        pagecount (u/ceil (/ (count aftersale-cases) (:pagesize pages 10)))]

    (when (> (or (:page pages) 0) pagecount)
      (swap! aftersales-list-settings-atom assoc-in [:pages :page] 1))

    (list
      [:table.yc-table
       [:caption.yc-table-caption.hidden-from-view "View your returns and repairs history"]
       [:colgroup
        [:col]
        [:col]
        [:col]
        [:col]
        [:col]]
       [:thead.yc-thead
        [:tr.yc-tr
         [:th.yc-th {:scope "col"} "Reference No."]
         [:th.yc-th.yc-th--centered {:scope "col"}
          [:span.clip-text.unclip-text--l "Date "]
          "Requested"]
         [:th.yc-th.yc-th--centered {:scope "col"} "Status"]
         [:th.yc-th.yc-th--centered {:scope "col"}
          "Resolution"
          [:span.clip-text.unclip-text--l " Order"]]
         [:th.yc-th.yc-th--centered {:scope "col"}
          [:span.clip-text.unclip-text--l "No. of "]
          "Items"]
         [:th.yc-th.yc-th--centered {:scope "col"} "Options"]]]

       (into
         [:tbody.yc-tbody
          {:id :aftersaleslist}]
         (map (partial aftersales-history-line app-atom)
           (->>
             aftersale-cases
             (drop (* (- (:page pages 1) 1) (:pagesize pages 10)))
             (take (:pagesize pages 10)))))]


      (web-common/pagination-control app-atom (rum/cursor aftersales-list-settings-atom :pages) pagecount {:scroll-to "aftersaleslist"}))))


(rum/defc aftersales < rum/reactive [app-atom]
  (let [action-atom (cmn/action-cursor app-atom)
        aftersale-cases (cmn/curact action-atom [:return-cases])]
    [:div
     [:div.yc-section.yc-section--standard
      [:div.flex-grid-group
       [:div.flex-grid-block.flex-grid-block--m-1-2
        [:div.flex-grid-content
         [:div.aftersales-choice.card
          [:a.block-link (urlstate/href-props app-atom "myaccount" "createrepair")
           [:div.aftersales-choice__content
            (headings/heading "Repairs" {:type :h2 :size :small :center true})
            [:p.yc-paragraph.u-text-center
             "If an item you purchased needs repairing we'll collect it, inspect it and and get it repaired for you."]
            [:div.u-text-center
             (buttons/button-web "Arrange a repair"
               {:type :span-button
                :style :primary
                :size :default})]]]]]]
       [:div.flex-grid-block.flex-grid-block--m-1-2
        [:div.flex-grid-content
         [:div.aftersales-choice.card.choice-card
          {:data-choice-card "Or"}
          [:div.aftersales-choice__content
           [:a.block-link (urlstate/href-props app-atom "myaccount" "createreturn")
            (headings/heading "Returns & Exchanges" {:type :h2 :size :small :center true})
            [:p.yc-paragraph.u-text-center
             "If an item you purchased arrived broken, is faulty or isn't what you had in mind, we're here to help."]
            [:div.u-text-center
             (buttons/button-web "Arrange an exchange"
               {:type :span-button
                :style :primary
                :size :default})]]]]]]]]

     (if (not-empty aftersale-cases)
       [:div.dashboard
        (aftersales-history-table app-atom)
        (toaster/loading-overlay app-atom :web.myaccount/aftersales)]

       [:div.no-data-wrapper.yc-section.yc-section--standard
        [:div.no-data-view
         [:p [:b "You don't have any past returns."] [:br] "Are you returning an item that was given to you as a gift?"]
         [:div.button-wrapper.button-wrapper--align-center
          (buttons/button-web "Contact Us"
            {:href "/help.htm"
             :style :dark})]]
        (toaster/loading-overlay app-atom :web.myaccount/aftersales)])]))

(defmethod flow/render-screen :web.myaccount/aftersales [app-atom _]
  (awm.common/screen-wrapper app-atom
    (aftersales app-atom)))

(defmethod t/transition-open :web.myaccount/aftersales [app-atom _ _]
  (toaster/open-overlay app-atom :web.myaccount/aftersales)
  (comms/ajax-get :web.myaccount/aftersales {}))

(defmethod comms/receive :web.myaccount/aftersales [app-atom e]
  (toaster/close-overlay app-atom :web.myaccount/aftersales)
  (swap! (cmn/action-cursor app-atom) assoc :return-cases (:return-cases e)))